import { useAuth } from '../lib/auth';
import { t } from '../lib/theme';

export default function MobileNav({ view, setView, isDirector, isFaculty, isFellow, pending, pendingEvals, canEvaluate }) {
  const { signOut } = useAuth();

  const fellowTabs = [
    { id: 'home',        label: 'Home',      icon: '🏠' },
    { id: 'new',         label: 'Log Case',  icon: '＋' },
    { id: 'log',         label: 'My Log',    icon: '☰' },
    { id: 'evaluations', label: 'Evals',     icon: '★', badge: pendingEvals },
  ];
  const facultyTabs = [
    { id: 'home',     label: 'Home',     icon: '🏠' },
    { id: 'faculty',  label: 'Reviews',  icon: '✓', badge: pending },
    { id: 'evaluate', label: 'Evaluate', icon: '★' },
  ];
  const directorTabs = [
    { id: 'home',         label: 'Home',      icon: '🏠' },
    { id: 'quiz',         label: 'Quiz',      icon: '📝' },
    { id: 'director',     label: 'Fellows',   icon: '⊞' },
    { id: 'entries',      label: 'Review',    icon: '✓' },
    { id: 'eval_history', label: 'Evals',     icon: '★' },
    ...(canEvaluate ? [{ id:'evaluate', label:'Evaluate', icon:'✎' }] : []),
  ];

  const tabs = isDirector ? directorTabs : isFaculty ? facultyTabs : fellowTabs;

  return (
    <div style={{ position:'fixed', bottom:0, left:0, right:0, zIndex:200, background:t.slate, display:'flex', alignItems:'stretch', borderTop:'1px solid rgba(255,255,255,0.07)', paddingBottom:'env(safe-area-inset-bottom)' }}>
      {tabs.map(tab => {
        const isActive = view === tab.id;
        return (
          <button key={tab.id} onClick={() => setView(tab.id)}
            style={{ flex:1, padding:'10px 4px 8px', border:'none', background: isActive?'rgba(200,149,108,0.12)':'transparent', display:'flex', flexDirection:'column', alignItems:'center', gap:3, cursor:'pointer', position:'relative', borderTop:`2px solid ${isActive?t.clay:'transparent'}` }}>
            <span style={{ fontSize:18 }}>{tab.icon}</span>
            <span style={{ fontSize:10, fontWeight:isActive?600:400, color:isActive?t.clay:'rgba(245,239,230,0.5)', fontFamily:t.fonts.body }}>{tab.label}</span>
            {tab.badge > 0 && (
              <div style={{ position:'absolute', top:4, right:'50%', marginRight:-16, width:16, height:16, borderRadius:'50%', background:t.clay, display:'flex', alignItems:'center', justifyContent:'center', fontSize:9, fontWeight:700, color:'#fff' }}>{tab.badge}</div>
            )}
          </button>
        );
      })}
      <button onClick={() => signOut()}
        style={{ width:50, padding:'10px 4px 8px', border:'none', background:'transparent', display:'flex', flexDirection:'column', alignItems:'center', gap:3, cursor:'pointer' }}>
        <span style={{ fontSize:18 }}>⏻</span>
        <span style={{ fontSize:10, color:'rgba(245,239,230,0.35)', fontFamily:t.fonts.body }}>Out</span>
      </button>
    </div>
  );
}
